import React from 'react'
import { Link } from 'react-router-dom'
import { LABELS } from '../constants/staticText'
import { fileUrl } from '../functions/fileUrl'
import VisuallyHidden from '../../lib/a11y/VisuallyHidden'
import { bildMasse } from '../../lib/functions/bildMasse'

// Kachelraster des Messe-Hubs, in der kuratierten Array-Reihenfolge des
// Backoffice (kein order-Feld, Spec Kachelsteuerung §3). Mongo-Kacheln führen
// auf eine eigene Route (:sectionSlug aus tiles[].slug); WP-Kacheln (#60)
// verlinken direkt auf die WordPress-Seite — im selben Tab, damit
// Browser-Zurueck in den Hub fuehrt; nur mit newTab in einem neuen (die sechs
// belegten _blank-Faelle des Altsystems, Spec §3 Weg 3).
// Der Bildbereich hat immer feste Höhe, auch ohne hinterlegtes Motiv — sonst
// rutscht der Knopf auf den Titelbalken (Vorlage: .imagepart in
// scss/live/include-subpages-url-hub.css).
//
// Die Titel sind h2: die Kacheln stehen unter der h1 der Messeseite (#236).
const tileImageSrc = (tile) => tile.imageUrl || (tile.image && fileUrl(tile.image.fileId))

// Auf einer verlinkten Kachel ist das Abzeichen („mehr erfahren »") Schmuck:
// es steht vor dem Titel und machte jeden Verweisnamen gleich (#236). Der Name
// ist der Titel; „coming soon" bleibt lesbar, es ist die einzige Auskunft.
const TileImage = ({ tile, badge, badgeSchmuck }) => (
    <span className="event-tile-imagepart">
        {tileImageSrc(tile) && <img src={tileImageSrc(tile)} alt="" className="event-tile-image" loading="lazy" decoding="async" {...bildMasse(tile.image)} />}
        <span className="event-tile-badge" aria-hidden={badgeSchmuck || undefined}>{badge}</span>
    </span>
)

const TileInner = ({ tile, badge, badgeSchmuck = false }) => (
    <>
        <TileImage tile={tile} badge={badge} badgeSchmuck={badgeSchmuck} />
        <h2 className="event-tile-title">{tile.title}</h2>
    </>
)

const TileLink = ({ tile, eventSlug }) => (
    tile.url ? (
        <a
            className="event-tile-inner"
            href={tile.url}
            target={tile.newTab ? '_blank' : undefined}
            rel={tile.newTab ? 'noreferrer' : undefined}
        >
            <TileInner tile={tile} badge={LABELS.more} badgeSchmuck />
            {tile.newTab && <VisuallyHidden>{LABELS.opensNewTab}</VisuallyHidden>}
        </a>
    ) : (
        <Link className="event-tile-inner" to={`/events/${eventSlug}/${tile.slug}/`}>
            <TileInner tile={tile} badge={LABELS.more} badgeSchmuck />
        </Link>
    )
)

const EventTiles = ({ eventSlug, tiles }) => (
    <ul className="event-tiles">
        {tiles.map(tile => (
            <li key={tile.slug || tile.wpPageId} className={`event-tile ${'comingSoon' === tile.state ? 'is-coming-soon' : ''}`}>
                {'comingSoon' === tile.state ? (
                    <div className="event-tile-inner">
                        <TileInner tile={tile} badge={LABELS.comingSoon} />
                    </div>
                ) : (
                    <TileLink tile={tile} eventSlug={eventSlug} />
                )}
            </li>
        ))}
    </ul>
)

export default EventTiles
